import React from 'react';
import { css } from 'twin.macro';
import GradientCard from './GradientCard';
import CISCOIcon from '../../assets/images/ciso-icon.svg';
import ShieldSettingsIcon from '../../assets/images/shield-settings-icon.svg';
import ShieldCloudIcon from '../../assets/images/shield-cloud-icon.svg';
import { Container } from '../atoms/Containers';

const GradientCardsSection = () => {
    return (
        <Container className='pt-16 pb-16 lg:pb-16'>
            <h3
                className='text-primaryBlack text-3xl font-semibold font-montserrat max-w-xl lg:max-w-lg mx-auto lg:mx-0'
            >
                Who uses Cyscale
            </h3>
            <div
                className='grid grid-cols-12 gap-x-5 mt-12'
                css={css`
                    overflow: hidden;
                `}
            >
                <div className='col-span-12 lg:col-span-4'>
                    <GradientCard
                        icon={CISCOIcon}
                        title={'CISOs & CTOs'}
                        text={
                            <>
                                Don’t let cloud security hold you back from building that killer app.
                                <br />
                                <br />
                                Keep your team happy and motivated by automating tedious work for security and
                                compliance.
                            </>
                        }
                        link={'/products/cloud-security-posture-management/'}
                    />
                </div>
                <div className='col-span-12 lg:col-span-4'>
                    <GradientCard
                        icon={ShieldSettingsIcon}
                        title={'SecOps & Cloud Engineers'}
                        text={
                            <>
                                Identify problems and respond fast with guided remediation.
                                <br />
                                <br />
                                Transform manual work with automation to get stuff done better and faster.
                            </>
                        }
                        link={'/products/cloud-security-posture-management/'}
                    />
                </div>
                <div className='col-span-12 lg:col-span-4'>
                    <GradientCard
                        icon={ShieldCloudIcon}
                        title={'MSPs & MSSPs'}
                        text={
                            <>
                                Offer high-margin managed cloud security services.
                                <br />
                                <br />
                                <br />
                                Start with cloud assessments and upsell remediation and continuous monitoring.
                            </>
                        }
                        link={'/products/security-knowledge-graph/'}
                    />
                </div>
            </div>
        </Container>
    );
};

export default GradientCardsSection;
